import sanitizeHtml from 'sanitize-html'

import settings from 'src/config/settings'

interface IDownloadQbrAttachment {
  uid: string
  fileName: string
  formId: number
  fieldName: string
}

export const downloadQbrAttachment = async ({
  uid,
  formId,
  fileName,
  fieldName,
}: IDownloadQbrAttachment) => {
  const url = `${settings.dataServerUrl}/form/${formId}/attachments/v2/${uid}/${fieldName}`

  const link = document.createElement('a')
  link.setAttribute('href', sanitizeHtml(url))
  link.setAttribute('target', '_blank')
  link.setAttribute('download', fileName)

  const element = document.body || document.documentElement

  element.appendChild(link)
  link.click()
  // small crutch to imitate server response to show loader overlay
  await new Promise((resolve) => setTimeout(() => resolve(true), 1500))
  element.removeChild(link)
}
